import { LogoutIcon } from '@/lib/icons'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/contexts/AuthContext'

export function HeaderMobile() {
  const { logout, isTeams } = useAuth()

  return (
    <header className="flex h-14 shrink-0 items-center justify-between border-b border-sidebar-border bg-sidebar-primary px-4 shadow-sm">
      <img
        src="/Tencon_logo.png"
        alt="Tencon"
        className="h-12 -ml-3 object-contain"
      />
      {!isTeams && (
        <Button
          variant="ghost"
          size="icon"
          onClick={logout}
          className="text-neutral-200 hover:text-white hover:bg-white/10"
          aria-label="Kirjaudu ulos"
        >
          <LogoutIcon className="h-5 w-5" />
        </Button>
      )}
    </header>
  )
}
